export default "__VITE_ASSET__740c5a05__"